// JS-side color values for libraries that need hex strings (charts, SweetAlert2).
// Tailwind classes use the same palette: keep in sync with tailwind.config.js.

export const COLORS = {
  brand: '#4f46e5', // brand-600 (indigo, matches the logo)
  brandLight: '#eef2ff', // brand-50
  success: '#059669', // emerald-600
  warning: '#d97706', // amber-600
  danger: '#e11d48', // rose-600
  muted: '#94a3b8', // slate-400
  border: '#e2e8f0', // slate-200
  text: '#0f172a', // slate-900
};

// One colour per transaction type, used by the dashboard chart and its legend.
// Validated with the dataviz palette checks (lightness band, chroma, colour-blind separation,
// normal-vision floor, 3:1 contrast) against the card surface of each mode, and kept clear of
// the status colours (green / amber / red) so a series never reads as success, pending or failed.
export const SERVICE_COLORS = {
  light: {
    recharge: '#4f46e5', // indigo-600
    billPayment: '#0891b2', // cyan-600
    payment: '#a21caf', // fuchsia-700
  },
  dark: {
    recharge: '#6366f1', // indigo-500
    billPayment: '#0891b2', // cyan-600
    payment: '#d946ef', // fuchsia-500
  },
};
